import { isNil } from "lodash";

import getFreeGifts from "@helpers/items/getFreeGifts";
import getProductDefaultConfiguration from "@helpers/products/getProductDefaultConfiguration";

import type { Product } from "@typings/product/product";

export const refreshGifts = (cartItems: Product[]) => {
  const gifts = getFreeGifts();

  const total = cartItems.reduce(
    (acc, { configuration }) => acc + configuration.price * configuration.quantity,
    0
  );
  const hasSubscriptionItem = cartItems.some(
    (ci) => ci.configuration.offer.name === "Monthly Subscription"
  );

  const giftsToAdd = gifts
    .filter((gift) => {
      const { from } = gift.additionalDetails;

      if (isNil(from)) return false;
      if (from === 0 && !hasSubscriptionItem) return false;
      if (from > total) return false;

      return true;
    })
    .map((g) => ({ item: g, configuration: getProductDefaultConfiguration(g) }));

  return [...cartItems.filter((ci) => ci.item.category.name !== "Free Gift"), ...giftsToAdd];
};
